// src/lib/version.js
// Sichtbare Fassungsnummer der App.
//
// Warum das nötig ist: Am Telefon lässt sich nicht mit Strg+Shift+R nachhelfen.
// Wenn dort etwas anders aussieht als am PC, war bisher nicht feststellbar, ob
// das Handy überhaupt die neue Fassung hat. Jetzt steht sie unten im Menü
// "Mehr" und in der Kopfzeile — vorlesen genügt.
//
// MUSS zusammen mit CACHE_VERSION in public/service-worker.js hochgezählt
// werden. Beides gehört zum selben Stand.
export const APP_VERSION = 'v107';
